import {
  BackofficePromoCustomerType,
  BackofficePromoMechanism,
  BackofficePromoQuery,
  BackofficePromoResponse,
  BackofficePromoStatus,
  BackofficePromoType,
} from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useInfiniteQuery } from '@tanstack/react-query';

export const getPromoList = async (
  token: string,
  status: BackofficePromoQuery,
  page: number,
  search_query: string,
  size: number,
  start_date: number,
  end_date: number,
  customer_type: BackofficePromoCustomerType,
  status_promo: BackofficePromoStatus,
  promo_type: BackofficePromoType,
  mechanism: BackofficePromoMechanism
) => {
  const url = `/backoffice/promo`;
  const { data } = await apiInstance(token).get<BackofficePromoResponse>(url, {
    params: {
      status: status,
      page,
      size,
      search_query,
      start_date,
      end_date,
      customer_type,
      mechanism,
      promo_type,
      status_promo,
    },
  });

  return {
    data: data.data,
    nextPage: page < data.pagination.pages ? page + 1 : null,
  };
};

export const BACKOFFICE_PROMO_QUERY_KEY = 'BackofficePromo';

export function usePromoList(
  status: BackofficePromoQuery,
  search_query: string,
  size: number,
  start_date: number,
  end_date: number,
  customer_type?: BackofficePromoCustomerType,
  mechanism?: BackofficePromoMechanism,
  promo_type?: BackofficePromoType,
  status_promo?: BackofficePromoStatus
) {
  const { access_token } = useAuthStore();
  return useInfiniteQuery({
    queryKey: [
      BACKOFFICE_PROMO_QUERY_KEY,
      status,
      search_query,
      size,
      start_date,
      end_date,
      customer_type,
      status_promo,
      promo_type,
      mechanism,
    ],
    queryFn: ({ pageParam }) =>
      getPromoList(
        access_token,
        status,
        pageParam,
        search_query,
        size,
        start_date,
        end_date,
        customer_type,
        status_promo,
        promo_type,
        mechanism
      ),
    initialPageParam: 1,
    getNextPageParam: ({ nextPage }) => nextPage,
    gcTime: 0,
  });
}
